var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "img-fluid mb-4 rounded",
      attrs: { src: "/media/header/profil.jpg", alt: "Profil" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-4" }, [
      _c("div", { staticClass: "col-md-4 col-lg-3" }, [
        _c(
          "div",
          { staticClass: "list-group shadow-sm" },
          _vm._l(_vm.links, function(link) {
            return _vm.canSeeLink(link)
              ? _c(
                  "router-link",
                  {
                    key: link.title,
                    staticClass:
                      "list-group-item d-flex justify-content-between align-items-center oswald text-primary",
                    class: { active: _vm.isActive(link) },
                    attrs: { tag: "a", to: link.route }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(link.title) +
                        "\n                        "
                    ),
                    _c(
                      "span",
                      { staticClass: "badge badge-primary badge-dark" },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-18px",
                          class: link.icon
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-8 col-lg-9" },
        [
          _c(
            "transition",
            { attrs: { name: "component-fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }